<template>
  <div class="sponsor_index">
    <page-header :title="$tc('sponsor.name', 2)">
    </page-header>
    <page-content>
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <ntm-block :collapsable="false">
            <template slot="options">
              <!--          <input type="text" class="form-control" :placeholder="$tc('search')"  v-model="search">-->
              <button @click="createEmptySponsorAndEdit()" type="button" class="btn btn-sm btn-success">
                {{ $t('action.addNew') }}
              </button>
            </template>
            <div class="table-responsive">
              <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading">
                <template slot="actions" slot-scope="{row}">
                  <router-link :to="{ name: 'sponsors.edit', params: {uuid: row.uuid }}" class="btn btn-sm btn-primary" v-tooltip="$t('action.edit')">
                    <i class="fa fa-pencil"></i>
                  </router-link>
                </template>
              </ntm-table>
            </div>
          </ntm-block>
        </div>
      </div>
      <!-- END Full Table -->
    </page-content>
  </div>
</template>
<script>
import SponsorService from '@/services/sponsor.service'
import basicIndexMixin from '@/mixins/basic.index.mixin'
import { useCreateNewEntity } from '@/use/useCreateNewEntity'

export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        },
        {
          name: 'landingPage',
          prop: 'showOnWebsiteLandingPage',
          type: 'bool'
        },
        {
          name: 'websiteFooter',
          prop: 'showOnWebsiteFooter',
          type: 'bool'
        },
        {
          name: 'livestreamGraphics',
          prop: 'showOnLivestreamGraphicSponsorOverlay',
          type: 'bool'
        }
      ]
    }
  },
  setup () {
    const { createEmptySponsorAndEdit } = useCreateNewEntity()

    return { createEmptySponsorAndEdit }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      SponsorService.index(this.search).then((response) => {
        this.setData(response.data)
      })
    }
  }
}
</script>
